import { render, staticRenderFns } from "./term.vue?vue&type=template&id=b4d1d942&scoped=true&"
import script from "./term.vue?vue&type=script&lang=js&"
export * from "./term.vue?vue&type=script&lang=js&"
import style0 from "./term.vue?vue&type=style&index=0&id=b4d1d942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1d942",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CStack: require('@chakra-ui/vue').CStack})
